import Link from 'next/link';
import Image from 'next/image';

interface IconLinkProps {
  href: string;
  label: string;
  icon: string;
  width: number;
  height: number;
}

const IconLink = ({ href = '', label, icon, width, height }: IconLinkProps) => {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      <Image src={`/${icon}.svg`} width={width} height={height} alt={label} />
    </a>
  );
};

export default function SocialFooter(): React.ReactElement {
  return (
    <>
      <p className="font-semibold uppercase lg:mb-2 mr-auto lg:mr-0">
        Follow Us:
      </p>
      <div className="flex gap-3">
        <IconLink
          href="https://www.reddit.com/r/DailyPolished"
          label="Reddit"
          icon="reddit"
          width={20}
          height={20}
        />
        <IconLink
          href="https://www.instagram.com/dailypolished_/"
          label="Instagram"
          icon="insta"
          width={20}
          height={20}
        />
        <IconLink
          href="https://twitter.com/PolishedDaily"
          label="Twitter"
          icon="twitter"
          width={23}
          height={19}
        />
        <IconLink
          href="https://www.facebook.com/Daily-Polished-100925499242227"
          label="Facebook"
          icon="facebook"
          width={10}
          height={18}
        />
      </div>
    </>
  );
}
